<template>
	<div class="paymentSaoma">
		<div class="header">
			<rs-row>
				<rs-col :span="24">
					<div class="grid-content bg-purple-dark">
						<span style="margin-left: 10px;font-weight: bold;font-size: 15px;">账单支付</span>
					</div>
				</rs-col>
			</rs-row>
		</div>
		
		<div class="main" style="margin-top: 50px;padding: 20px;" v-for="(item, index) in paylist">
			<!-- <rs-form :model="numberValidateForm">
				
			</rs-form> -->
			<div style="display: flex;justify-content: space-between;font-weight: bold;">
				<div>{{index+1}}.公司名称：{{item.companyName}}</div>
				<div v-if="link">支付状态：支付成功</div>
				<div v-if="lonk">支付状态：未支付</div>
			</div>
			 <rs-table
			  v-loading.fullscreen.lock="fullscreenLoading"
			    ref="singleTable"
			    :data="paylist[index].itemAccountReceivableVOList"
			    highlight-current-row
			    border
			    style="width: 100%;margin-top: 10px;">
			    <rs-table-column
				header-align='center'
				label='序号'
			      type="index"
			      width="50">
			    </rs-table-column>
			    <rs-table-column
			      property="boothCode"
				  header-align='center'
				  align='center' show-overflow-tooltip
			      label="铺位编号"
				  
			      width="120">
			    </rs-table-column>
			    <rs-table-column
				header-align='center'
			      property="buildingName"
				  align='center' show-overflow-tooltip
			      label="楼栋"
			      width="120">
			    </rs-table-column>
			    <rs-table-column
				header-align='center'
			      property="floorName"
				  align='center' show-overflow-tooltip
			      label="楼层">
			    </rs-table-column>
				<rs-table-column
				header-align='center'
				  property="statementBeginEndTime"
				  align='center' show-overflow-tooltip
				  label="账单周期">
				</rs-table-column>
				<rs-table-column
				header-align='center'
				  property="paymentDue"
				  align='center' show-overflow-tooltip
				  label="付款日期">
				</rs-table-column>
				<rs-table-column
				  property="unpaidAmount"
				  align='center' show-overflow-tooltip
				  header-align='center'
				  label="缴纳金额(元)">
				</rs-table-column>
				<rs-table-column
				  property="itemName"
				  header-align='center'
				  align='center' show-overflow-tooltip
				  label="费用项">
				</rs-table-column>
				<rs-table-column
				header-align='center'
				  property="contractCode"
				  align='center' show-overflow-tooltip
				  label="合同号">
				</rs-table-column>
			  </rs-table>
			  <div style="display: flex;justify-content: space-between;margin-top: 20px;" >
				  <div>
					  <vue-qr v-if="lcnk"  :text="item.js_pay_url" :size="200"></vue-qr>
					  	<!-- <div v-if="lcnk" id="qrcode" ref="qrcode"></div> -->
					  	<!-- <div style="text-align: center;height: 50px;line-height: 50px;border-radius: 10px;">请扫描上方二维码进行支付</div> -->
					  
				  </div>
				  <div style="display: flex;font-weight: bold;">
					  
					  <div style="width: 220px;">账号：{{item.accountNumber}}</div>
					  <div style="width: 200px;">合计金额：{{item.orderAmt}}</div>
				  </div>
			  </div>
		</div>
		<div class="fotter" style="text-align: right;padding: 20px;">
			<rs-button @click='close'>关闭</rs-button>
		</div>
	</div>
</template>

<script>
	// import vueQr from 'vue-qr'
	import vueQr from 'vue-qr'
	//二维码
	import QRCode from 'qrcodejs2';
	import Http from "@/api/api";
	import API from "@/api/pay";
	import utils from "@/utils/utils";
	export default{
		components: {
			vueQr,	 
		},
		data(){
			return{
				fullscreenLoading:false,
				link:false,
				lonk:true,
				lcnk:true,
				tableData:[],
				url:[],
				merOrderNo:'',
				timer:'',
				paylist:[],
				status:''
			}
		},
		created() {
			console.log(typeof this.num)
			// this.qrcodeScan()
			console.log(window.location.href)
			this.pay()
			// this.paylist=this.num
		// this.paylist.map((item)=>{
		// 	console.log(item.cc)
		// 	this.tableData=item.cc
		// })
		// for(var i in this.paylist){
		// 	console.log(this.paylist[i])
		// 	this.tableData=this.paylist[i].cc
		// }
		// 	// this.tableData=this.num.cc
		// 	console.log(this.tableData)
		// 	console.log(this.paylist)
		},
		methods:{
			//生成二维码
			qrcodeScan() {
				//这里是为了 每次进入方法就删除上一张二维码
				console.log(this.$refs.qrcode)
				this.$refs.qrcode.innerHTML = ''
				// document.getElementById("qrcode").innerHTML = "";
				// 生成二维码
				// console.log(this.url);
				var qrcode = new QRCode("qrcode", {
					text: this.url[0], // 这里为动态二维码地址
					width: 150,
					height: 150,
					colorDark: "#000000",
					colorLight: "#ffffff",
					correctLevel: QRCode.CorrectLevel.H,
				});
			},
			pay(){
				this.fullscreenLoading=true,
				setTimeout(() => {
					this.fullscreenLoading = false;
				}, 2000);
				let phone = utils.getSession("shopVo");
				let params = {
					statementNo: this.$route.query.categoryList,
					itemCode: this.$route.query.classifystr,
					businessId:phone,
				};	
				API.unifiedPreOrder7011(params).then((res) => {
					if (res.data.code == 200) {
						console.log("获取合同列表", res);
						// this.tableData=res.data.data.itemAccountReceivableVOList
						this.paylist=res.data.data
						this.timer=setInterval(()=>{
							this.paylist.map((item)=>{
								this.merOrderNo=item.merOrderNo
								// this.timer=setInterval(()=>{
									this.getOrderlist()
								// },6000)
							})
								 },3000)	
						// window.open(res.data.data.pc_cashier_url);
					} else {}
				});
			},
			getOrderlist(){
				let params = {
					merOrderNo: this.merOrderNo,
				};
				API.getPayRecordByMerOrderNo(params).then((res) => {
					if (res.data.code == 200) {
						console.log("获取合同列表", res.data.data.tradeStatus);
						this.status=res.data.data.tradeStatus
						//判断支付的状态如果为success，隐藏掉二维码，显示支付成功
				if(res.data.data.tradeStatus=="SUCCESS"){
					clearInterval(this.timer)
					this.link=true
					this.lonk=false
					//二维码隐藏
					this.lcnk=false
					
					// this.handleQuery()
				}else{
					this.link=false
					this.lonk=true
					//二维码显示
					this.lcnk=true
				}
					}
				});
			},
			close(){
				this.$router.back()
				clearInterval(this.timer)
			}
		}
	}
</script>

<style scoped="scoped" lang="less">
	@import "../../organizationManage/style/index.less";
	.rs-row {
		margin-bottom: 20px;
	
		&:last-child {
			margin-bottom: 0;
		}
	}
	
	
</style>
